<script>
import { addHours } from './helpers/datetime.js';
import Alerts from './components/Alerts.svelte';
import Forecast from './components/Forecast.svelte';
import Login from './Login.svelte';
import Logout from './Logout.svelte';
import { user } from './stores.js';
import Drawer from './components/Drawer.svelte';

function listForecastHours() {
  return ["00", "03", "06", "09", "12", "15", "18", "21"];
}

function getNextForecastHourOffset(currentUtcHour) {
  let forecastHours = listForecastHours();

  for (var i in forecastHours) {
    if (parseInt(currentUtcHour, 10) > parseInt(forecastHours[i], 10)) {
      continue;
    }

    return parseInt(forecastHours[i], 10) - parseInt(currentUtcHour, 10);
  }
  // if the loop finishes, return 00 of the next day
  return 24 - parseInt(currentUtcHour, 10);
}

/*
Using current UTC hour, retrieves next available forecast hour from list of
possible values (Env. Can. only supplies forecasts for every 3 hours step).
After finding the next available forecast date, assemble list of formatted
time values for the API call (`yyyy-MM-ddThh:00:00Z).
*/
function listForecastTimes() {
  let timeList = [];
  let d = new Date(); // utc date
  d.setTime(d.getTime() + (d.getTimezoneOffset() * 60 * 1000));
  d.setMinutes(0);
  d.setSeconds(0);

  let currentUtcHour = d.getHours();
  // set first forecast time to the next available forecast time given by Env. Can.
  addHours(d, getNextForecastHourOffset(currentUtcHour));

  for (var i = 0; i < 4; i++) {
    timeList.push(d.getTime());

    addHours(d, 3);
  }

  return timeList;
}
</script>

<style>
.forecasts {
  display: flex;
}
@media only screen and (max-width: 600px) {
  .forecasts {
    display: block;
  }
}
</style>
<Alerts />
<Drawer />
	<div class="container">
    <h1>Forecast</h1>
    <div class="forecasts">
        <Forecast time="" />
    {#each listForecastTimes() as time}
	      <Forecast time={time} />
    {/each}
    </div>
  </div>
